<template>
    <div class="w-100">
        <div class="d-flex w-100">
            <div class="mr-2" style="width: calc(200% / 3)">
                <v-text-field @input="setSearch" :value="search" append-icon="mdi-magnify" label="Rechercher par nom"
                    clearable outlined class="mb-4" hide-details>
                </v-text-field>

                <v-select
                    v-if="cadh.type === 'OBJ'"
                    label="Catégorie"
                    outlined
                    chips
                    small-chips
                    deletable-chips
                    :items="categories"
                    @input="setSelectedCategories"
                    :value="selectedCategories"
                    item-value="id"
                    item-text="label"
                    class="mb-4"
                    multiple>
                </v-select>

                <v-select label="Etat du paiement" outlined chips small-chips deletable-chips :items="paymentStates"
                    @input="setSelectedPaymentStates" :value="selectedPaymentStates" item-value="code" item-text="label"
                    multiple>
                </v-select>
            </div>

            <div class="mr-2 ml-2" style="width: calc(200% / 3)">
                <v-text-field @input="setEmailSearch" :value="emailSearch" append-icon="mdi-magnify" label="Rechercher par email"
                              clearable outlined class="mb-4" hide-details>
                </v-text-field>

                <v-select label="Mode de paiement" outlined chips small-chips deletable-chips :items="paymentOptions"
                    @input="setSelectedPaymentOptions" :value="selectedPaymentOptions" item-value="id" item-text="label"
                    class="mb-4" multiple>
                </v-select>

                <v-select
                    v-if="cadh.type === 'OBJ'"
                    label="Commune"
                    outlined
                    chips
                    small-chips
                    deletable-chips
                    :items="communes"
                    @input="setSelectedCommunes"
                    :value="selectedCommunes"
                    item-value="id"
                    item-text="label"
                    class="mb-4"
                    multiple>
                </v-select>


            </div>

            <div class="ml-2" style="width: calc(200% / 3)">
                <v-select label="Statut" outlined chips small-chips deletable-chips :items="cadhFormStates"
                    @input="setSelectedWebFormStates" :value="selectedWebFormStates" item-value="code" item-text="label"
                    class="mb-4" multiple>
                </v-select>

                <v-select
                    v-if="cadh.type === 'OBJ'"
                    label="Tag"
                    outlined
                    chips
                    @input="setSelectedTags"
                    :items="tags"
                    :value="selectedTags"
                    no-data-text="Aucun tag n'a encore été créé"
                    small-chips
                    deletable-chips
                    item-value="id"
                    item-text="name"
                    class="mb-4"
                    multiple>
                </v-select>

                <v-select
                  label="Options facturables"
                  outlined
                  chips
                  small-chips
                  deletable-chips
                  :items="optionTypes"
                  @input="setSelectedOptionTypes"
                  :value="selectedOptionTypes"
                  item-value="value"
                  item-text="label"
                  multiple>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"

export default {
    name: "Filters",
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            paymentOptions: [],
            optionTypes: [
                {
                   label: "Immédiatement",
                   value: true
                },
                {
                    label: 'Ultérieurement',
                    value: false
                },
            ],
        }
    },
    methods: {
        ...mapMutations('cadhFilter', [
            'setSearch', 'setSelectedCategories', 'setSelectedCommunes', 'removeUnavailableStates',
            'setSelectedWebFormStates', 'setSelectedTags', 'setSelectedPaymentOptions', 'setSelectedPaymentStates',
            'setSelectedOptionTypes', 'setEmailSearch',
        ]),
        ...mapMutations('resource', ['setWebFormStates']),
        getPaymentOptions() {
            let hash    = this.$route.params.hash
            let cadhId  = parseInt(atob(hash))

            this.$http.get('auth/campaigns/cadh/payment-options/' + cadhId).then(res => {
                this.paymentOptions = res.body.data.payment_options
            })
        }
    },
    computed: {
        ...mapState('cadhFilter',
            ['search', 'selectedCategories', 'selectedWebFormStates',
                'selectedTags', 'selectedCommunes', 'selectedPaymentOptions', 'selectedPaymentStates', 'cadh',
                'selectedOptionTypes', 'emailSearch']
        ),
        ...mapState('resource', ['cadhFormStates', 'paymentStates']),
        ...mapState('account', ['categories', 'tags', 'communes']),
    },
    created() {
        this.$store.dispatch('account/fetchCategories')
        this.$store.dispatch('account/fetchCommunes')

        if(this.$route.params.hash !== undefined) {
            this.$store.dispatch('resource/fetchCadhFormStates')
            this.$store.dispatch('resource/fetchPaymentStates')
        } else {
            let states = [
                { code: 'WITHOUT_EMAIL',    label: 'Sans destinataire' },
                { code: 'WITHOUT_WEB_FORM', label: 'Non envoyé' }
            ]
            this.setWebFormStates(states)
            this.removeUnavailableStates()
        }

        this.$store.dispatch('account/fetchTags')
        this.getPaymentOptions()
    }
}
</script>